// extracted by mini-css-extract-plugin
module.exports = {"item":"DropPanel_item_37VUa","itemSelected":"DropPanel_itemSelected_2TvaC"};